import React from 'react';

import { postEntity } from '../../../utils/entityApi';
import withAuth from 'src/hoc/withAuth';

const oriState = {
  title: undefined,
};

class ModalDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = oriState;

    this.reset = this.reset.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.close = this.close.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  reset() {
    this.state = oriState;
  }

  close() {
    this.reset();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  handleSubmit() {
    if (this.props.onPostResult) {
      let json = {
        dashboard: {
          title: this.state.title,
        },
      };

      this.props.onPostResult('dashboard', postEntity(this.props.authFetch, 'dashboard', json));
      this.close();
    }
  }

  render() {
    if (this.props.isOpen === false) return null;

    return (
      <div className='modal myModal'>
        <div className='modal-dialog modal-xl'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h4 className='modal-title'>Créer Dashboard</h4>
              <button onClick={this.close} type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <form>
              <div className='modal-body'>
                <div className='form-group'>
                  <label>Titre</label>
                  <input
                    name='title'
                    value={this.state.title}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    placeholder='Mon Dashlet'
                  />
                </div>
              </div>
              <div className='modal-actions'>
                <button onClick={this.close} type='button' className='btn-link modal-action' data-dismiss='modal'>
                  Annuler
                </button>
                <button
                  onClick={this.handleSubmit}
                  type='button'
                  className='btn-link modal-action'
                  data-dismiss='modal'
                >
                  <strong>Créer</strong>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default withAuth(ModalDashboard);
